import { useDispatch, useSelector } from "react-redux";
import { updateUserPreferences } from "../../api/user/updateUserPreferences";
import { setSessionPreferences } from "../../store/Session";
import { StoreInterfaces } from "../../types/store/StoreInterfaces";
import { UserPreferences } from "../../types/ui";

export const useUserPreferences = () => {
  const dispatch = useDispatch();
  const session = useSelector((state: StoreInterfaces) => state.session);

  const updatePreferences = async (preferences: UserPreferences) => {
    try {
      await updateUserPreferences(
        session.accountId,
        session.userId,
        preferences,
      );
      dispatch(setSessionPreferences(preferences));
    } catch (error) {
      console.error(error);
    }
  };

  return {
    preferences: session?.preferences,
    updatePreferences,
  };
};
